declare namespace $ {

	export class $shm_hitalama_components_embed extends $mol_view {
		instance( ): any
		fqn( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=embed.view.tree.d.ts.map